import { supabase } from "@/integrations/supabase/client";

export type MonthlyReflection = {
  id: string;
  user_id: string;
  month_index: number;
  wins: string[];
  learnings: string | null;
  interests: string[];
  goals_next_month: string | null;
  challenges: string | null;
  mood: number | null;
  reflected_at: string;
};

export async function fetchMyReflection(monthIndex: number) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;
  const { data } = await supabase
    .from("monthly_reflections")
    .select("*")
    .eq("user_id", user.id)
    .eq("month_index", monthIndex)
    .maybeSingle();
  return (data as MonthlyReflection | null) ?? null;
}

export async function fetchAllMyReflections() {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return [];
  const { data } = await supabase
    .from("monthly_reflections")
    .select("*")
    .eq("user_id", user.id)
    .order("month_index", { ascending: true });
  return (data ?? []) as MonthlyReflection[];
}

export async function saveReflection(input: Omit<MonthlyReflection, "id" | "user_id" | "reflected_at">) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error("Not authenticated");
  const payload = {
    user_id: user.id,
    month_index: input.month_index,
    wins: input.wins,
    learnings: input.learnings,
    interests: input.interests,
    goals_next_month: input.goals_next_month,
    challenges: input.challenges,
    mood: input.mood,
  };
  const { data, error } = await supabase
    .from("monthly_reflections")
    .upsert(payload, { onConflict: "user_id,month_index" })
    .select()
    .maybeSingle();
  if (error) throw error;
  return data as MonthlyReflection;
}
